import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import cn from 'classnames';

import { formatAlternatePhoneNumber } from 'utils/formatPhoneNumber';
import { sendQuickpayText } from 'actions/applePay';
import { Button } from 'components/Button';
import OrDivider from 'components/OrDivider';

import styles from './styles.module.scss';

const SuggestApplePayButton = ({ loanId }) => {
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const onClick = (event) => {
    event.preventDefault();

    setIsLoading(true);
    setMessageType('');
    setMessage('');

    dispatch(sendQuickpayText({
      loanId,
      data: {},
      success: () => {
        const customerData = JSON.parse(sessionStorage.getItem('customerDetail'));
        const phoneNumber = (customerData?.phones || []).find((p) => p.isPrimary)?.phone;
        setMessage(`A text has been sent to ${formatAlternatePhoneNumber(phoneNumber)}. Please use this link to complete your payment via ApplePay from your iPhone or iPad.`);
        setMessageType('success');
        setIsLoading(false);
      },
      fail: (err) => {
        setMessage(get(err, 'data.message') || 'An error occurred. Please try again later.');
        setMessageType('danger');
        setIsLoading(false);
      },
    }));
  };

  return (
    <>
      <OrDivider />
      <Button isLoading={isLoading} color="primary" className={cn(styles.alternateApplePayBtn, 'w-100', !isLoading ? styles.noneTextTransformation : '')} onClick={onClick}>
        Click to Pay with Apple Pay
      </Button>
      {message ? <div className={cn(styles.alert, 'mt-1', styles[messageType])}>{message}</div> : null}
    </>
  );
};

SuggestApplePayButton.propTypes = {
  loanId: PropTypes.string,
};

SuggestApplePayButton.defaultProps = {
  loanId: '',
};

export default SuggestApplePayButton;
